import React from "react"
import Modal from "../../../../components/Modal"

interface ModalFieldProps {
  modalOpen: boolean
  onClose: () => void
  infoState: string
  setInfoState: any
  handleSaveState: any
  handleCloseInfoModal: any
  application: any
}

const EditApplicationNote: React.FC<ModalFieldProps> = ({
  modalOpen,
  onClose,
  infoState,
  setInfoState,
  handleSaveState,
  handleCloseInfoModal,
  application,
}) => {
  const handleClose = () => {
    handleCloseInfoModal()
    onClose()
  }

  const handleSave = () => {
    if (application?._id) {
      handleSaveState(application._id, infoState)
    }
  }

  return modalOpen ? (
    <Modal
      onClick={handleClose}
      classname="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      classname2="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-auto"
    >
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-gray-900">Başvuru Notu</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Not İçeriği</label>
            <textarea
              value={infoState}
              onChange={(e) => setInfoState(e.target.value)}
              placeholder="Yeni not giriniz..."
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              rows={4}
            />
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3 pt-4">
            <button
              onClick={handleClose}
              className="flex-1 px-4 py-2.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              Kapat
            </button>
            <button
              onClick={handleSave}
              className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              Kaydet
            </button>
          </div>
        </div>
      </div>
    </Modal>
  ) : null
}

export default EditApplicationNote
